// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-content-manage {
    width: 100%;
}

.app-content-manage h2 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 30px;
    color: #ffffff;
}

/* 등록 영역 */

.app-content-form {
    display: flex;
    gap: 12px;
    margin-bottom: 30px;
}

.app-content-form input {
    flex: 1 1;
    height: 52px;
    padding: 0 18px;

    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 14px;

    background: rgba(255,255,255,0.06);
    color: #ffffff;

    font-size: 15px;
}

.app-content-form input:focus {
    outline: none;
    border-color: #5b7cff;
}

.app-content-form button {
    width: 120px;

    border: none;
    border-radius: 14px;

    background: linear-gradient(
            135deg,
            #6f3cff,
            #2d9cff
    );

    color: white;

    font-weight: 700;

    cursor: pointer;

    transition: .2s;
}

.app-content-form button:hover {
    transform: translateY(-2px);
}

/* 목록 */

.app-content-list {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

/* 카드 */

.app-content-card {
    display: flex;
    align-items: center;

    gap: 24px;

    padding: 18px;

    border-radius: 20px;

    background: rgba(255,255,255,0.04);

    border: 1px solid rgba(255,255,255,0.08);

    transition: .2s;
}

.app-content-card:hover {
    background: rgba(255,255,255,0.06);
}

/* 썸네일 */

.app-thumbnail {
    width: 220px;
    height: 124px;

    object-fit: cover;

    border-radius: 14px;

    flex-shrink: 0;
}

/* 정보 */

.app-content-info {
    flex: 1 1;

    display: flex;
    flex-direction: column;

    gap: 10px;
}

.app-content-info h4 {
    margin: 0;

    color: white;

    font-size: 20px;

    font-weight: 700;

    line-height: 1.4;
}

/* 버튼 */

.app-content-actions {
    display: flex;
    gap: 10px;
}

.video-button {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    height: 40px;

    padding: 0 18px;

    border-radius: 10px;

    background: #6f3cff;

    color: white;

    text-decoration: none;

    font-size: 14px;

    font-weight: 600;
}

.edit-btn {
    height: 40px;

    padding: 0 18px;

    border: none;

    border-radius: 10px;

    background: #2d9cff;

    color: white;

    font-size: 14px;

    font-weight: 600;

    cursor: pointer;
}

.delete-btn {
    height: 40px;

    padding: 0 18px;

    border: none;

    border-radius: 10px;

    background: #ff4d67;

    color: white;

    font-size: 14px;

    font-weight: 600;

    cursor: pointer;
}

/* 모달 */

.modal-overlay {
    position: fixed;

    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background: rgba(
            0,
            0,
            0,
            0.7
    );

    display: flex;

    justify-content: center;

    align-items: center;

    z-index: 9999;

    backdrop-filter: blur(4px);
}

.modal-box {
    width: 700px;

    max-width: 95%;

    background: #1a1f2e;

    border: 1px solid rgba(
            255,
            255,
            255,
            0.08
    );

    border-radius: 20px;

    padding: 24px;
}

.modal-box h3 {
    margin-top: 0;

    margin-bottom: 20px;

    color: white;

    font-size: 24px;
}

.modal-box label {
    display: block;

    margin-top: 16px;

    margin-bottom: 8px;

    color: #d6d9e3;

    font-size: 14px;
}

.modal-box input {
    width: 100%;

    height: 50px;

    padding: 0 15px;

    box-sizing: border-box;

    border: 1px solid rgba(
            255,
            255,
            255,
            0.12
    );

    border-radius: 12px;

    background: rgba(
            255,
            255,
            255,
            0.05
    );

    color: white;
}

.modal-box textarea {
    width: 100%;

    min-height: 220px;

    padding: 15px;

    box-sizing: border-box;

    border: 1px solid rgba(
            255,
            255,
            255,
            0.12
    );

    border-radius: 12px;

    background: rgba(
            255,
            255,
            255,
            0.05
    );

    color: white;

    resize: vertical;
}

.modal-box input:focus,
.modal-box textarea:focus {
    outline: none;

    border-color: #5b7cff;
}

.modal-buttons {
    display: flex;

    justify-content: flex-end;

    gap: 10px;

    margin-top: 24px;
}

/* 모바일 */

@media (max-width: 900px) {

    .app-content-card {
        flex-direction: column;
        align-items: flex-start;
    }

    .app-thumbnail {
        width: 100%;
        height: auto;
    }

    .app-content-form {
        flex-direction: column;
    }

    .app-content-form button {
        width: 100%;
        height: 52px;
    }

    .modal-box {
        width: 95%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppContentManage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,UAAU;;AAEV;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,eAAe;;IAEf,wCAAwC;IACxC,mBAAmB;;IAEnB,kCAAkC;IAClC,cAAc;;IAEd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;;IAEZ,YAAY;IACZ,mBAAmB;;IAEnB;;;;KAIC;;IAED,YAAY;;IAEZ,gBAAgB;;IAEhB,eAAe;;IAEf,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,OAAO;;AAEP;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,OAAO;;AAEP;IACI,aAAa;IACb,mBAAmB;;IAEnB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB,kCAAkC;;IAElC,wCAAwC;;IAExC,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,QAAQ;;AAER;IACI,YAAY;IACZ,aAAa;;IAEb,iBAAiB;;IAEjB,mBAAmB;;IAEnB,cAAc;AAClB;;AAEA,OAAO;;AAEP;IACI,SAAO;;IAEP,aAAa;IACb,sBAAsB;;IAEtB,SAAS;AACb;;AAEA;IACI,SAAS;;IAET,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;AACpB;;AAEA,OAAO;;AAEP;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,oBAAoB;;IAEpB,mBAAmB;IACnB,uBAAuB;;IAEvB,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,qBAAqB;;IAErB,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;IACI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;IACI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA,OAAO;;AAEP;IACI,eAAe;;IAEf,MAAM;IACN,OAAO;;IAEP,WAAW;IACX,YAAY;;IAEZ;;;;;KAKC;;IAED,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB,aAAa;;IAEb,0BAA0B;AAC9B;;AAEA;IACI,YAAY;;IAEZ,cAAc;;IAEd,mBAAmB;;IAEnB;;;;;KAKC;;IAED,mBAAmB;;IAEnB,aAAa;AACjB;;AAEA;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;AACnB;;AAEA;IACI,cAAc;;IAEd,gBAAgB;;IAEhB,kBAAkB;;IAElB,cAAc;;IAEd,eAAe;AACnB;;AAEA;IACI,WAAW;;IAEX,YAAY;;IAEZ,eAAe;;IAEf,sBAAsB;;IAEtB;;;;;KAKC;;IAED,mBAAmB;;IAEnB;;;;;KAKC;;IAED,YAAY;AAChB;;AAEA;IACI,WAAW;;IAEX,iBAAiB;;IAEjB,aAAa;;IAEb,sBAAsB;;IAEtB;;;;;KAKC;;IAED,mBAAmB;;IAEnB;;;;;KAKC;;IAED,YAAY;;IAEZ,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;IAEb,qBAAqB;AACzB;;AAEA;IACI,aAAa;;IAEb,yBAAyB;;IAEzB,SAAS;;IAET,gBAAgB;AACpB;;AAEA,QAAQ;;AAER;;IAEI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".app-content-manage {\n    width: 100%;\n}\n\n.app-content-manage h2 {\n    font-size: 32px;\n    font-weight: 700;\n    margin-bottom: 30px;\n    color: #ffffff;\n}\n\n/* 등록 영역 */\n\n.app-content-form {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 30px;\n}\n\n.app-content-form input {\n    flex: 1;\n    height: 52px;\n    padding: 0 18px;\n\n    border: 1px solid rgba(255,255,255,0.15);\n    border-radius: 14px;\n\n    background: rgba(255,255,255,0.06);\n    color: #ffffff;\n\n    font-size: 15px;\n}\n\n.app-content-form input:focus {\n    outline: none;\n    border-color: #5b7cff;\n}\n\n.app-content-form button {\n    width: 120px;\n\n    border: none;\n    border-radius: 14px;\n\n    background: linear-gradient(\n            135deg,\n            #6f3cff,\n            #2d9cff\n    );\n\n    color: white;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: .2s;\n}\n\n.app-content-form button:hover {\n    transform: translateY(-2px);\n}\n\n/* 목록 */\n\n.app-content-list {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n/* 카드 */\n\n.app-content-card {\n    display: flex;\n    align-items: center;\n\n    gap: 24px;\n\n    padding: 18px;\n\n    border-radius: 20px;\n\n    background: rgba(255,255,255,0.04);\n\n    border: 1px solid rgba(255,255,255,0.08);\n\n    transition: .2s;\n}\n\n.app-content-card:hover {\n    background: rgba(255,255,255,0.06);\n}\n\n/* 썸네일 */\n\n.app-thumbnail {\n    width: 220px;\n    height: 124px;\n\n    object-fit: cover;\n\n    border-radius: 14px;\n\n    flex-shrink: 0;\n}\n\n/* 정보 */\n\n.app-content-info {\n    flex: 1;\n\n    display: flex;\n    flex-direction: column;\n\n    gap: 10px;\n}\n\n.app-content-info h4 {\n    margin: 0;\n\n    color: white;\n\n    font-size: 20px;\n\n    font-weight: 700;\n\n    line-height: 1.4;\n}\n\n/* 버튼 */\n\n.app-content-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.video-button {\n    display: inline-flex;\n\n    align-items: center;\n    justify-content: center;\n\n    height: 40px;\n\n    padding: 0 18px;\n\n    border-radius: 10px;\n\n    background: #6f3cff;\n\n    color: white;\n\n    text-decoration: none;\n\n    font-size: 14px;\n\n    font-weight: 600;\n}\n\n.edit-btn {\n    height: 40px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    border-radius: 10px;\n\n    background: #2d9cff;\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 600;\n\n    cursor: pointer;\n}\n\n.delete-btn {\n    height: 40px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    border-radius: 10px;\n\n    background: #ff4d67;\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 600;\n\n    cursor: pointer;\n}\n\n/* 모달 */\n\n.modal-overlay {\n    position: fixed;\n\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n\n    background: rgba(\n            0,\n            0,\n            0,\n            0.7\n    );\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    z-index: 9999;\n\n    backdrop-filter: blur(4px);\n}\n\n.modal-box {\n    width: 700px;\n\n    max-width: 95%;\n\n    background: #1a1f2e;\n\n    border: 1px solid rgba(\n            255,\n            255,\n            255,\n            0.08\n    );\n\n    border-radius: 20px;\n\n    padding: 24px;\n}\n\n.modal-box h3 {\n    margin-top: 0;\n\n    margin-bottom: 20px;\n\n    color: white;\n\n    font-size: 24px;\n}\n\n.modal-box label {\n    display: block;\n\n    margin-top: 16px;\n\n    margin-bottom: 8px;\n\n    color: #d6d9e3;\n\n    font-size: 14px;\n}\n\n.modal-box input {\n    width: 100%;\n\n    height: 50px;\n\n    padding: 0 15px;\n\n    box-sizing: border-box;\n\n    border: 1px solid rgba(\n            255,\n            255,\n            255,\n            0.12\n    );\n\n    border-radius: 12px;\n\n    background: rgba(\n            255,\n            255,\n            255,\n            0.05\n    );\n\n    color: white;\n}\n\n.modal-box textarea {\n    width: 100%;\n\n    min-height: 220px;\n\n    padding: 15px;\n\n    box-sizing: border-box;\n\n    border: 1px solid rgba(\n            255,\n            255,\n            255,\n            0.12\n    );\n\n    border-radius: 12px;\n\n    background: rgba(\n            255,\n            255,\n            255,\n            0.05\n    );\n\n    color: white;\n\n    resize: vertical;\n}\n\n.modal-box input:focus,\n.modal-box textarea:focus {\n    outline: none;\n\n    border-color: #5b7cff;\n}\n\n.modal-buttons {\n    display: flex;\n\n    justify-content: flex-end;\n\n    gap: 10px;\n\n    margin-top: 24px;\n}\n\n/* 모바일 */\n\n@media (max-width: 900px) {\n\n    .app-content-card {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .app-thumbnail {\n        width: 100%;\n        height: auto;\n    }\n\n    .app-content-form {\n        flex-direction: column;\n    }\n\n    .app-content-form button {\n        width: 100%;\n        height: 52px;\n    }\n\n    .modal-box {\n        width: 95%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
